export function browserIntakeIssue(durationSeconds: number): string | null {
  if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) {
    return "This file could not be read as a playable video. Export an MP4 or WebM file and try again.";
  }
  return null;
}
